/**
 * menuUsers.js
 */

// Import
import "./menuUsers.scss";
import $ from 'jquery';

$(document).ready(function() {

});